import { useLanguage } from '@/contexts/LanguageContext';
import { usePosts } from '@/contexts/PostsContext';
import { useAdmin } from '@/contexts/AdminContext';
import PostCard from '@/components/base/PostCard';
import { Link } from 'react-router-dom';

const FeaturedPosts = () => {
  const { t, lang } = useLanguage();
  const { posts } = usePosts();
  const { isAdmin } = useAdmin();
  const featured = posts
    .filter((p) => p.featured && (p.isPublic || isAdmin))
    .filter((p) => p.language === 'both' || p.language === lang)
    .slice(0, 3);

  return (
    <section className="py-20 px-6 bg-stone-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-2">
              {t('Featured', '주요 글')}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-stone-800">
              {t('Selected Posts', '선별된 게시물')}
            </h2>
          </div>
          <Link
            to="/issues"
            className="hidden sm:flex items-center gap-1 text-sm text-stone-500 hover:text-stone-800 cursor-pointer transition-colors whitespace-nowrap"
          >
            {t('View All', '전체 보기')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-8">
          <Link
            to="/issues"
            className="text-sm text-stone-500 border border-stone-200 rounded-full px-6 py-2 hover:bg-stone-100 cursor-pointer whitespace-nowrap transition-colors"
          >
            {t('View All Issues', '전체 이슈 보기')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPosts;
